var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M15,28.5C7.6,28.5,1.5,22.4,1.5,15S7.6,1.5,15,1.5S28.5,7.6,28.5,15S22.4,28.5,15,28.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M15 2c7.2 0 13 5.8 13 13s-5.8 13-13 13S2 22.2 2 15 7.8 2 15 2M15 1C7.3 1 1 7.3 1 15s6.3 14 14 14 14-6.3 14-14S22.7 1 15 1L15 1zM24 29.4l-.5-.8c2-1.3 3.7-3 5-5l.8.5C28 26.2 26.2 28 24 29.4zM1.5 6.5L.6 6C2 3.8 3.8 2 6 .6l.5.8C4.5 2.7 2.7 4.5 1.5 6.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,26.5C8.7,26.5,3.5,21.3,3.5,15S8.7,3.5,15,3.5S26.5,8.7,26.5,15S21.3,26.5,15,26.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M15,4c6.1,0,11,4.9,11,11s-4.9,11-11,11S4,21.1,4,15S8.9,4,15,4 M15,3C8.4,3,3,8.4,3,15 s5.4,12,12,12s12-5.4,12-12S21.6,3,15,3L15,3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M19.3,19.8c-0.1,0-0.3,0-0.4-0.1l-4.6-4.6l5.4-8c0.2-0.2,0.5-0.3,0.7-0.1c0.2,0.2,0.3,0.5,0.1,0.7 l-4.9,7.3l4,4c0.2,0.2,0.2,0.5,0,0.7C19.6,19.8,19.4,19.8,19.3,19.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M15 13.5A1.5 1.5 0 1 0 15 16.5A1.5 1.5 0 1 0 15 13.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5d4de",
    d: "M15 5A1 1 0 1 0 15 7 1 1 0 1 0 15 5zM15 23A1 1 0 1 0 15 25 1 1 0 1 0 15 23z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c5d4de",
    d: "M24 14A1 1 0 1 0 24 16A1 1 0 1 0 24 14Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c5d4de",
    d: "M6 14A1 1 0 1 0 6 16A1 1 0 1 0 6 14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/timing.98a1ebd4c3c7fbb6313b94491bfcdd0d.svg";
export { ForwardRef as ReactComponent };